import { render } from "./UsQuotePeriodOverview.vue?vue&type=template&id=4d4d8651"
import script from "./UsQuotePeriodOverview.vue?vue&type=script&lang=js"
export * from "./UsQuotePeriodOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__